let req = require.context('.', true, /\.jpg$/);
export default req.keys().map(file_path => req(file_path));



// WEBPACK FOOTER //
// ./src/core/images/frontpage/index.js